import Index from '../../views/setting/assignLoanOfficerOldClient/Index'
import List from '../../views/setting/assignLoanOfficerOldClient/List'
import Permissions from '@/permissions'

export const assignLoanOfficerOldClientRouters = {
  path: 'assign-loan-officer-old-client',
  component: Index,
  redirect: '',
  meta: {
    permissions: [Permissions.backend.setting.assignLoanOfficerOldClient.manage],
    groups: 'assign-loan-officer-old-client'
  },
  children: [
    {
      path: '',
      name: 'list-assign-loan-officer-old-client',
      component: List,
      meta: {
        permissions: [
          Permissions.backend.setting.assignLoanOfficerOldClient.list
        ],
        groups: 'assign-loan-officer-old-client',
        breadcrumb: [
          {
            name_en: 'Setting',
            name_km: 'ការកំណត់'
          },
          {
            name_en: 'Assign Loan Officer (Old Client)',
            name_km: 'ចាត់តាំងមន្រ្តីឥណទាន (អតិថិជនចាស់)'
          },
          {
            name_en: 'List',
            name_km: 'បញ្ជី'
          }
        ]
      }
    }
  ]
}
